<ion-tabs (ionTabsWillChange)="onTabChange($event)">
  <ion-tab-bar
    slot="bottom"
    [translucent]="true"
    [ngClass]="platformReady && currentPlatform === 'ios' ? 'pb-8' : 'pb-5'"
    class="pt-3"
  >
    @for (tab of tabs; track tab) {
      <ion-tab-button
        [tab]="tab.tab"
        class="fs-13 area-normal"
      >
        <span
          [ngClass]="isPrime ? 'icon-prime' : 'icon'"
          class="{{ tab.icon }} fs-32"
        ></span>
        <div class="text-trim-1">{{ tab.label | translate }}</div>
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
